import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, EnvelopeSimple, ArrowUp } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';
import { companyInfo } from '../i18n/translations';

export const Footer = () => {
  const { t, language } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B1320] pt-24 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 pb-16 border-b border-white/10">
          {/* Logo & Tagline */}
          <div className="lg:col-span-1">
            <img
              src={companyInfo.logo}
              alt="JKM Engineering"
              className="h-16 w-auto object-contain mb-6 brightness-0 invert"
            />
            <p className="text-white/60 text-sm leading-relaxed" style={{ fontFamily: "'Manrope', sans-serif" }}>
              {t.footer.tagline}
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">
              {language === 'fr' ? 'Contact' : 'Contact'}
            </h4>
            <div className="space-y-4">
              <div className="flex gap-3 text-white/60">
                <Phone size={20} className="text-[#FF6B00] flex-shrink-0" weight="bold" />
                <div className="text-sm">
                  {companyInfo.phones.map((phone, i) => (
                    <p key={i}>{phone}</p>
                  ))}
                </div>
              </div>
              <div className="flex gap-3 text-white/60">
                <MapPin size={20} className="text-[#FF6B00] flex-shrink-0" weight="bold" />
                <p className="text-sm">{companyInfo.address}</p>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm flex items-center gap-2">
              <EnvelopeSimple size={20} className="text-[#FF6B00]" weight="bold" />
              Email
            </h4>
            <div className="space-y-4">
              <div className="flex gap-3 text-white/60">
                <EnvelopeSimple size={20} className="text-[#FF6B00] flex-shrink-0" weight="bold" />
                <div className="text-sm">
                  <p>{companyInfo.email}</p>
                  <p>{companyInfo.emailTeam}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/40">
            © {currentYear} {companyInfo.name}. {t.footer.rights}.
          </p>
          
          {/* Back to Top */}
          <motion.button
            onClick={scrollToTop}
            whileHover={{ y: -3 }}
            className="flex items-center gap-2 text-sm text-white/60 hover:text-[#FF6B00] transition-colors"
            data-testid="back-to-top"
          >
            <ArrowUp size={16} weight="bold" />
            {language === 'fr' ? 'Retour en haut' : 'Back to top'}
          </motion.button>
        </div>
      </div>
    </footer>
  );
};
